import styled from "styled-components";
import Colors from "../../constants/Colors";
import {deviceMax} from "../../../styles/device";


export const SecurityWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  background-color: ${Colors.white};
  border-radius: 6px;
  margin: 26px 20px;

  @media ${deviceMax.tablet} {
    flex-direction: column-reverse;
    margin-bottom: 0;
    margin-top: 0;
  }
`;

export const SecurityRow = styled.div`
  position: relative;
  flex: 1;

  @media ${deviceMax.tablet} {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

export const SecurityTitle = styled.h1`
  position: relative;
  font-weight: 800;
  font-size: 18px;
  line-height: 55px;
  letter-spacing: 0;
  text-transform: uppercase;
  color: ${Colors.brandColor};
  margin: 20px 0 0 56px;

  @media ${deviceMax.tablet} {
    color: ${Colors.black};
    margin-left: 0;
  }
`;

export const SecurityText = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 26px;
  padding-right: 46px;
  padding-left: 56px;
  padding-bottom: 32px;
  box-sizing: border-box;

  @media ${deviceMax.tablet} {
    flex-direction: column;
    margin-top: 0;
    padding-left: 42px;
    padding-right: 45px;
    padding-bottom: 0;
  }

  > p {
    font-weight: 400;
    font-size: 18px;
    line-height: 30px;
    letter-spacing: 0;
    color: ${Colors.black};
    margin-left: 50px;

    @media ${deviceMax.tablet} {
      margin-left: 0;
      text-align: center;
      font-size: 16px;
      line-height: 24px;
    }
  }

`;

export const SecurityBgImage = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background: url('/next/assets/images/about-us/about-us-security.png') no-repeat center center;
  background-size: cover;
  z-index: 1;

  @media ${deviceMax.tablet} {
    height: 182px;
  }
`;
